export default __webpack_public_path__ + "static/media/falcon-mode-dark.287d941d.jpg";